<ph-dialog [open]="open"
           size="md"
           [heading]="'Add ' + (data?.onlyDepositAccounts ? 'Deposit ' : '') + 'Bank Account'"
           (ph-close)="closeDialog()">
    <app-bank-account-properties *ngIf="open"
                                 #propertiesForm
                                 [onlyDepositAccounts]="data?.onlyDepositAccounts"></app-bank-account-properties>

    <ph-actions slot="footer">
        <ph-button variant="secondary" mode="filled" aria-label="cancel" (click)="closeDialog()">Cancel</ph-button>
        <ph-button aria-label="save account" [disabled]="isSaving" (click)="saveAccount()">Save bank account</ph-button>
    </ph-actions>
</ph-dialog>
